// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-list-item {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 16px;
  background-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  min-height: 64px;
}

.contact-list-item.selected {
  background-color: rgba(0, 0, 0, 0.1);
}

.contact-list-item.hovered {
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.contact-list-item-avatar-container {
  position: relative;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  flex-shrink: 0;
}

.contact-list-item-avatar {
  position: relative;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  flex-shrink: 0;
}

.contact-list-item-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.contact-list-item-presence-indicator {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid white;
  background-color: #cccccc;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.contact-list-item-check {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgb(74, 74, 74);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
}

.contact-list-item-check span {
  color: white;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}

.contact-list-item-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.contact-list-item-name {
  font-size: 16px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.contact-list-item-admin {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
  color: rgb(222, 72, 88);
  font-family: roboto, sans-serif;
  margin-top: 2px;
}

.contact-list-item-description {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.contact-list-item-timestamp {
  font-size: 12px;
  color: rgb(153, 153, 153);
  margin-left: 8px;
  flex-shrink: 0;
}

.contact-list-item-organization {
  color: rgb(153, 153, 153);
  font-size: 12px;
  font-weight: normal;
  margin-top: 4px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: 15px;
}

.contact-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  width: 100%;
}

.contact-list-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 100px;
}

.contact-list-loading-text {
  color: var(--color-text-secondary, #666);
  font-family: Roboto, sans-serif;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/ContactList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;AACjB","sourcesContent":[".contact-list-item {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  background-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  min-height: 64px;\n}\n\n.contact-list-item.selected {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.contact-list-item.hovered {\n  background-color: rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.contact-list-item-avatar-container {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.contact-list-item-avatar {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.contact-list-item-avatar img {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.contact-list-item-presence-indicator {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 2px solid white;\n  background-color: #cccccc;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n\n.contact-list-item-check {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: rgb(74, 74, 74);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n}\n\n.contact-list-item-check span {\n  color: white;\n  -webkit-user-select: none;\n  user-select: none;\n  cursor: pointer;\n}\n\n.contact-list-item-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1;\n  min-width: 0;\n}\n\n.contact-list-item-name {\n  font-size: 16px;\n  font-weight: 400;\n  color: rgb(0, 0, 0);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.contact-list-item-admin {\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: normal;\n  color: rgb(222, 72, 88);\n  font-family: roboto, sans-serif;\n  margin-top: 2px;\n}\n\n.contact-list-item-description {\n  font-size: 12px;\n  color: #666;\n  margin-top: 2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.contact-list-item-timestamp {\n  font-size: 12px;\n  color: rgb(153, 153, 153);\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.contact-list-item-organization {\n  color: rgb(153, 153, 153);\n  font-size: 12px;\n  font-weight: normal;\n  margin-top: 4px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  line-height: 15px;\n}\n\n.contact-list {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 100%;\n  width: 100%;\n}\n\n.contact-list-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  height: 100px;\n}\n\n.contact-list-loading-text {\n  color: var(--color-text-secondary, #666);\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
